module.exports = __webpack_public_path__ + "img/logo-sm.dd8f962a.png";